import moment from 'moment';
import { DEFAULT_SHOW_DATE_FORMAT, REPORT_TYPE } from '@gtintel/platform-constants';
const formatDate = date => moment(date).isValid() ? moment(date).format(DEFAULT_SHOW_DATE_FORMAT) : '-';
var PartnerStatus = /*#__PURE__*/function (PartnerStatus) {
  PartnerStatus[PartnerStatus["pending"] = -1] = "pending";
  PartnerStatus[PartnerStatus["refused"] = 0] = "refused";
  PartnerStatus[PartnerStatus["accepted"] = 1] = "accepted";
  return PartnerStatus;
}(PartnerStatus || {});
export const convertProjectsToTableData = (projects, adminsById) => projects.map(project => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const proposedPartner = project.proposals.pop();
  const partner = project.partner?.id ? `${project.partner?.first_name} ${project.partner?.last_name}` : proposedPartner ? `${proposedPartner?.partner?.first_name} ${proposedPartner?.partner?.last_name}
      ${proposedPartner?.partner_accept !== 1 ? `(Partner ${PartnerStatus[proposedPartner?.partner_accept]})` : `(Client ${PartnerStatus[proposedPartner?.client_accept]})`}` : '-';
  return {
    key: project.id,
    status: project.status ?? '-',
    projectId: {
      key: project.id,
      value: `#${project.id}`
    },
    client: {
      key: project.client?.id,
      value: project.client?.id ? `${project.client?.first_name} ${project.client?.last_name}` : '-'
    },
    source: {
      key: project.source,
      value: project.source ?? '-'
    },
    partner: {
      key: project.partner?.id ?? proposedPartner?.partner?.id,
      value: partner
    },
    requestedAnonymity: {
      key: project.id,
      value: project.request_anonymity ? 'Yes' : 'No'
    },
    qaRequired: {
      key: project.id,
      value: project.qa_required
    },
    npCompletionDate: {
      key: project.id,
      value: formatDate(project.start_date)
    },
    startDate: formatDate(project.start_date),
    endDate: formatDate(project.requested_completion_date),
    createdDate: formatDate(project.created_date),
    projectName: {
      key: project.id,
      value: project.name ?? '-'
    },
    cxLead: project.cx_lead_id ? adminsById[project.cx_lead_id]?.full_name : '',
    totalRevenue: `${project.currency}${project.final_price}`,
    profit: `${project.currency}${Number(project.final_price) - Number(project.partner_price)}`,
    tags: project.tags,
    teamName: project.team_name,
    flags: project.flags
  };
});
export function formatProjectReportDetails(projectReportDetails) {
  const formattedProjectReportDetail = {
    logos: [],
    executiveSummaries: [],
    individualComments: [],
    atmospherics: [],
    chartGraphs: [],
    images: [],
    attachments: []
  };
  Array.isArray(projectReportDetails) && projectReportDetails.forEach(reportDetail => {
    switch (reportDetail.type) {
      case REPORT_TYPE.REPORTSECTIONTYPE_LOGO:
        formattedProjectReportDetail.logos.push(reportDetail);
        break;
      case REPORT_TYPE.REPORTSECTIONTYPE_SUMMARY:
        formattedProjectReportDetail.executiveSummaries.push(reportDetail);
        break;
      case REPORT_TYPE.REPORTSECTIONTYPE_INDIVIDUAL:
        formattedProjectReportDetail.individualComments.push(reportDetail);
        break;
      case REPORT_TYPE.REPORTSECTIONTYPE_ATMOSPHERIC:
        formattedProjectReportDetail.atmospherics.push(reportDetail);
        break;
      case REPORT_TYPE.REPORTSECTIONTYPE_CHART:
        formattedProjectReportDetail.chartGraphs.push(reportDetail);
        break;
      case REPORT_TYPE.REPORTSECTIONTYPE_IMAGE:
        formattedProjectReportDetail.images.push(reportDetail);
        break;
      case REPORT_TYPE.REPORTSECTIONTYPE_ATTACHMENT:
        formattedProjectReportDetail.attachments.push(reportDetail);
        break;
    }
  });
  return formattedProjectReportDetail;
}
export function formatTagList(tags) {
  if (!Array.isArray(tags)) return [];
  const newTagList = tags.map(tag => {
    return {
      key: tag.id.toString(),
      value: tag.id,
      color: tag.tag_group_code ?? tag.tag_group,
      label: tag.name
    };
  });
  return [...new Map(newTagList.map(tag => [tag.key, tag])).values()];
}